import React from 'react';
import { noop } from '../../lib/noop';
import { SignIn } from './SignIn';
import { Guest } from './Guest';
import './Authentication.scss';
import './CheckoutAuthentication.scss';

interface Props {
  changePayment: () => void;
}

export const CheckoutAuthentication: React.FC<Props> = ({ changePayment }) => {
  return (
    <div className="CheckoutAuthentication">
      <SignIn
        title="Welcome Back"
        message="Please sign in for a quicker checkout experience."
        className="CheckoutAuthentication__section"
        onAuth={noop}
        changePayment={changePayment}
      />
      <Guest className="CheckoutAuthentication__section" onAuth={noop} />
    </div>
  );
};
